module.exports = __webpack_public_path__ + "fbe7f2fa9700dd3ca4629c5875e14e7f.svg";